function LogoIcon({ height, fill }) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={height} height={height} fill='none' viewBox='0 0 101 101'>
			<path fill={fill} d='M.305 100.744l59.482-78.451-36.206-5.171L.305 52.463V.743h100L46.425 74.02l32.328 5.165 21.552-30.17-.001 51.729h-100z'></path>
		</svg>
	);
}

export default LogoIcon;
